import { IVentureExperienceLevelBase } from '../../models/ventureExperienceLevels';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export type IVentureExperienceLevel = IVentureExperienceLevelBase;

export const listVentureExperienceLevelsService = async (
  ventureId: string,
): Promise<IVentureExperienceLevel[]> => {
  const { data } = await jhsfBookingsApi.get<IVentureExperienceLevel[]>(
    `/ventures/${ventureId}/experience-levels`,
  );

  return data;
};
